<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  size: {
    type: String,
    default: 'default',
    validator: value => ['default', 'md'].includes(value),
  },
});

const emit = defineEmits(['change']);

const { t } = useI18n();

const modelValue = defineModel({
  type: Boolean,
  default: false,
});

const isMd = computed(() => props.size === 'md');

const updateValue = () => {
  modelValue.value = !modelValue.value;
  emit('change', !modelValue.value);
};
</script>

<template>
  <button
    type="button"
    class="group relative flex-shrink-0 rounded-full select-none focus:outline-none focus:ring-1 focus:ring-n-brand focus:ring-offset-n-slate-2 focus:ring-offset-2 transition-colors duration-200 ease-in-out"
    :class="[
      isMd ? 'h-[22px] w-[38px]' : 'h-4 w-7',
      modelValue ? 'bg-n-brand' : 'bg-n-slate-6',
    ]"
    role="switch"
    :aria-checked="modelValue"
    @click="updateValue"
  >
    <span class="sr-only">{{ t('SWITCH.TOGGLE') }}</span>
    <span
      class="absolute top-1/2 ltr:left-0.5 rtl:right-0.5 -translate-y-1/2 transition-transform duration-[350ms] ease-[cubic-bezier(0.34,1.56,0.64,1)]"
      :class="
        modelValue
          ? isMd
            ? 'ltr:translate-x-4 rtl:-translate-x-4 group-active:ltr:translate-x-[14px] rtl:group-active:-translate-x-[14px]'
            : 'ltr:translate-x-3 rtl:-translate-x-3 group-active:ltr:translate-x-[6px] rtl:group-active:-translate-x-[6px]'
          : 'ltr:translate-x-0 rtl:translate-x-0'
      "
    >
      <span
        class="block rounded-full bg-n-background shadow-md transition-[width] duration-[180ms] ease-in-out"
        :class="
          isMd
            ? 'h-[18px] w-[18px] group-active:w-[22px]'
            : 'h-3 w-3 group-active:w-[18px]'
        "
      />
    </span>
  </button>
</template>
